var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section-posts2 section-posts-planner-view" },
    [
      _c(
        "div",
        { staticClass: "navigations" },
        [
          _c("div", { staticClass: "navigation-date" }, [
            _c(
              "div",
              {
                staticClass: "btn-radius",
                on: {
                  mouseenter: function($event) {
                    _vm.eventIsDrag && _vm.goToToday()
                  },
                  click: _vm.goToToday
                }
              },
              [_vm._v("Aujourd'hui")]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius icon",
                on: {
                  mouseenter: function($event) {
                    _vm.eventIsDrag && _vm.prev()
                  },
                  click: _vm.prev
                }
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-left" })]
            ),
            _c(
              "div",
              {
                staticClass: "btn-radius icon",
                on: {
                  mouseenter: function($event) {
                    _vm.eventIsDrag && _vm.next()
                  },
                  click: _vm.next
                }
              },
              [_c("i", { staticClass: "fa-solid fa-chevron-right" })]
            ),
            _c("div", { staticClass: "date" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.models.date,
                    expression: "models.date"
                  }
                ],
                attrs: { type: "date" },
                domProps: { value: _vm.models.date },
                on: {
                  click: function(e) {
                    return e.target.showPicker()
                  },
                  change: _vm.setDateFromDatePiker,
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.models, "date", $event.target.value)
                  }
                }
              }),
              _c("h4", [_vm._v(_vm._s(_vm.dateFormat))]),
              _c("i", { staticClass: "fa-solid fa-caret-down" })
            ])
          ]),
          _c(
            "div",
            { staticClass: "navigation-filter" },
            [
              _c(
                "div",
                {
                  staticClass: "btn-radius filter",
                  attrs: { "data-count": _vm.filterCount },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      _vm.filterIsOpen = true
                    }
                  }
                },
                [
                  _vm._v("\n                Filtrer\n                "),
                  _vm.filterIsOpen
                    ? _c("FilterNavigation", {
                        attrs: { filter: _vm.filter },
                        on: {
                          close: function($event) {
                            _vm.filterIsOpen = false
                          },
                          "update:filter": function($event) {
                            _vm.filter = $event
                          },
                          updateCalendar: _vm.refreshEvents
                        }
                      })
                    : _vm._e()
                ],
                1
              ),
              _c(
                "ContextMenu",
                {
                  attrs: {
                    options: [
                      { label: "Partager le planner", name: "sharePlanner" }
                    ],
                    id: "ContextMenuPlanner"
                  },
                  on: { clickOption: _vm.clickOption }
                },
                [
                  _c("div", { staticClass: "btn-radius icon" }, [
                    _c("i", { staticClass: "fa-solid fa-ellipsis-vertical" })
                  ])
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "btn-radius icon",
                  on: {
                    click: function($event) {
                      return _vm.getPlannerData(0)
                    }
                  }
                },
                [_c("i", { staticClass: "fa-solid fa-rotate-right" })]
              )
            ],
            1
          ),
          _c(
            "MainNavigation",
            _vm._g(
              {
                attrs: {
                  tabSelected: _vm.tabSelected,
                  currentViewType: _vm.currentViewType
                },
                on: { switchCurrentViewType: _vm.switchCurrentViewType }
              },
              _vm.$listeners
            )
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "planner", class: [_vm.currentViewType] },
        [
          _vm.isLoading
            ? _c("div", { staticClass: "loading-overlay" }, [
                _c("i", { staticClass: "fa-sharp fa-solid fa-spinner-third" }),
                _vm._v("Chargement")
              ])
            : _vm._e(),
          _c("FullCalendar", {
            ref: "fullCalendar",
            staticClass: "demo-app-calendar",
            attrs: { options: _vm.calendarOptions }
          })
        ],
        1
      ),
      _vm.eventIsDrag
        ? [
            _c("div", {
              staticClass: "prevMonthHover",
              on: { mouseenter: _vm.prev }
            }),
            _c("div", {
              staticClass: "nextMonthHover",
              on: { mouseenter: _vm.next }
            })
          ]
        : _vm._e(),
      _vm.eventIdSelected
        ? _c("DrawerPost", {
            attrs: { event: _vm.events[_vm.eventIdSelected] },
            on: { close: _vm.closeDrawer, deletePost: _vm.handlerDeletePost }
          })
        : _vm._e(),
      _vm.displaySharePlanner
        ? _c("SharePlanner", {
            attrs: { display: _vm.displaySharePlanner },
            on: {
              close: function($event) {
                _vm.displaySharePlanner = false
              }
            }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }